/**
 * Alliance categories carousel: Swiper per league panel (homepage + list sections).
 */
(function () {
  function ppvDesktopFromRoot(root) {
    var v = parseInt(root.getAttribute('data-ac-pages-per-view-desktop') || '6', 10);
    return isNaN(v) || v < 1 ? 6 : v;
  }

  function ppvMobileFromRoot(root) {
    var v = parseInt(root.getAttribute('data-ac-pages-per-view-mobile') || '4', 10);
    return isNaN(v) || v < 1 ? 4 : v;
  }

  function acTrackGapPx(track) {
    var page = track.querySelector('.alliance-cats__page');
    if (page) {
      var g0 = getComputedStyle(page).gap;
      if (g0 && g0 !== 'normal') {
        var px0 = parseFloat(g0);
        if (!isNaN(px0) && px0 >= 0) return px0;
      }
    }
    var g = getComputedStyle(track).gap;
    if (!g || g === 'normal') return 0;
    var px = parseFloat(g);
    return isNaN(px) ? 0 : px;
  }

  function refreshSwiperGap(viewport) {
    var sw = viewport._acSwiper;
    if (!sw) return;
    var track = viewport.querySelector('[data-ac-track]');
    if (!track) return;
    var gap = acTrackGapPx(track);
    sw.params.spaceBetween = gap;
    var bp = sw.params.breakpoints;
    if (bp) {
      for (var k in bp) {
        if (bp[k]) bp[k].spaceBetween = gap;
      }
    }
    sw.update();
  }

  function allianceCatsBindCarousel(root, opts) {
    opts = opts || {};
    var boundAttr = opts.attrBound || 'data-ac-js';
    if (!root || root.getAttribute(boundAttr) === '1') return;
    if (typeof Swiper === 'undefined') return;

    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-ac-league-panel]'));
    var dotOuters = Array.prototype.slice.call(root.querySelectorAll('[data-ac-league-dots]'));
    var prev = root.querySelector('[data-ac-prev]');
    var next = root.querySelector('[data-ac-next]');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ac-tab]'));
    if (!panels.length) return;

    root.setAttribute(boundAttr, '1');

    var ppvDesktop = ppvDesktopFromRoot(root);
    var ppvMobile = ppvMobileFromRoot(root);
    var league = 0;
    var cur = 0;
    var ro;

    function getPanel(li) {
      return root.querySelector('[data-ac-league-panel="' + li + '"]');
    }

    function getDotsOuter(li) {
      return root.querySelector('[data-ac-league-dots="' + li + '"]');
    }

    function getCtx(li) {
      var panel = getPanel(li);
      if (!panel) return null;
      var viewport = panel.querySelector('[data-ac-viewport]');
      var track = panel.querySelector('[data-ac-track]');
      if (!viewport || !track) return null;
      return { panel: panel, viewport: viewport, track: track };
    }

    function getPages(li) {
      var panel = getPanel(li);
      return panel ? Array.prototype.slice.call(panel.querySelectorAll('[data-ac-page]')) : [];
    }

    function isDesktop() {
      return window.matchMedia('(min-width: 750px)').matches;
    }

    function pagesPerView() {
      return isDesktop() ? ppvDesktop : ppvMobile;
    }

    function logicalMaxIndex(pageCount) {
      if (pageCount <= 0) return 0;
      var ppv = pagesPerView();
      return Math.max(0, Math.ceil(pageCount / ppv) - 1);
    }

    function getDots(li) {
      var outer = getDotsOuter(li);
      if (!outer) return [];
      var wrap = outer.querySelector(isDesktop() ? '[data-ac-dots-desktop]' : '[data-ac-dots-mobile]');
      if (!wrap) return [];
      return Array.prototype.slice.call(wrap.querySelectorAll('[data-ac-dot]'));
    }

    function getSwiper() {
      var ctx = getCtx(league);
      return ctx && ctx.viewport && ctx.viewport._acSwiper ? ctx.viewport._acSwiper : null;
    }

    function syncFromSwiper() {
      var sw = getSwiper();
      if (!sw) return;
      var n = getPages(league).length;
      if (n < 1) return;
      var ppv = pagesPerView();
      var ai = sw.activeIndex;
      var maxL = logicalMaxIndex(n);
      if (ai + ppv >= n) {
        cur = maxL;
      } else {
        cur = Math.min(maxL, Math.floor(ai / ppv));
      }
      var dotRow = getDots(league);
      if (dotRow.length) {
        cur = Math.min(Math.max(0, cur), dotRow.length - 1);
      }
      syncNav();
      syncDots();
    }

    function syncDots() {
      var dots = getDots(league);
      for (var d = 0; d < dots.length; d++) {
        var active = d === cur;
        dots[d].classList.toggle('is-active', active);
        dots[d].setAttribute('aria-selected', active ? 'true' : 'false');
      }
    }

    function syncNav() {
      var sw = getSwiper();
      var pages = getPages(league);
      var maxL = logicalMaxIndex(pages.length);
      if (!prev || !next) return;
      if (!sw || pages.length < 1) {
        prev.disabled = true;
        next.disabled = true;
        return;
      }
      prev.disabled = sw.isBeginning || maxL < 1;
      next.disabled = sw.isEnd || maxL < 1;
    }

    function showPage(index) {
      var sw = getSwiper();
      if (!sw) return;
      var pages = getPages(league);
      var n = pages.length;
      if (!n) return;
      var ppv = pagesPerView();
      var maxL = logicalMaxIndex(n);
      cur = Math.max(0, Math.min(index, maxL));
      var lastStart = Math.max(0, n - ppv);
      var target = cur >= maxL ? lastStart : cur * ppv;
      sw.slideTo(target);
    }

    function initAllSwipers() {
      panels.forEach(function (panel) {
        var viewport = panel.querySelector('[data-ac-viewport]');
        var track = panel.querySelector('[data-ac-track]');
        if (!viewport || !track) return;
        if (viewport._acSwiper) return;
        var gap = acTrackGapPx(track);
        viewport._acSwiper = new Swiper(viewport, {
          slidesPerView: ppvMobile,
          slidesPerGroup: ppvMobile,
          spaceBetween: gap,
          watchOverflow: true,
          nested: true,
          observer: true,
          observeParents: true,
          breakpoints: {
            750: {
              slidesPerView: ppvDesktop,
              slidesPerGroup: ppvDesktop,
              spaceBetween: gap,
            },
          },
          on: {
            slideChange: function () {
              if (panel.hidden) return;
              if (String(panel.getAttribute('data-ac-league-panel')) !== String(league)) return;
              syncFromSwiper();
            },
          },
        });
      });
    }

    function layout() {
      initAllSwipers();
      panels.forEach(function (panel) {
        var vp = panel.querySelector('[data-ac-viewport]');
        if (vp && vp._acSwiper) {
          refreshSwiperGap(vp);
        }
      });
      syncFromSwiper();
    }

    function selectLeague(li) {
      var n = parseInt(li, 10);
      league = isNaN(n) ? 0 : n;
      cur = 0;
      panels.forEach(function (p) {
        var id = p.getAttribute('data-ac-league-panel');
        p.hidden = String(id) !== String(league);
      });
      dotOuters.forEach(function (o) {
        var id = o.getAttribute('data-ac-league-dots');
        o.hidden = String(id) !== String(league);
      });
      tabs.forEach(function (tab, t) {
        var on = t === league;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      document.dispatchEvent(
        new CustomEvent('theme:alliance-league-change', {
          bubbles: true,
          detail: { leagueIndex: league },
        })
      );
      function afterPanelVisible() {
        layout();
        var sw = getSwiper();
        if (sw) {
          sw.slideTo(0, 0);
          syncFromSwiper();
        }
        attachRo();
      }
      if (typeof requestAnimationFrame !== 'undefined') {
        requestAnimationFrame(function () {
          requestAnimationFrame(afterPanelVisible);
        });
      } else {
        setTimeout(afterPanelVisible, 0);
      }
    }

    function attachRo() {
      var ctx = getCtx(league);
      if (!ctx || !ctx.viewport) return;
      if (typeof ResizeObserver === 'undefined') return;
      if (ro) ro.disconnect();
      ro = new ResizeObserver(function () {
        layout();
      });
      ro.observe(ctx.viewport);
    }

    var mql = window.matchMedia('(min-width: 750px)');
    function onBreakpoint() {
      layout();
    }
    if (mql.addEventListener) {
      mql.addEventListener('change', onBreakpoint);
    } else if (mql.addListener) {
      mql.addListener(onBreakpoint);
    }

    if (prev) {
      prev.addEventListener('click', function () {
        var sw = getSwiper();
        if (sw) sw.slidePrev();
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        var sw = getSwiper();
        if (sw) sw.slideNext();
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var ix = parseInt(tab.getAttribute('data-ac-tab-index'), 10);
        if (!isNaN(ix)) selectLeague(ix);
      });
    });

    dotOuters.forEach(function (outer) {
      outer.addEventListener('click', function (e) {
        var dot = e.target.closest('[data-ac-dot]');
        if (!dot || !outer.contains(dot)) return;
        var lid = outer.getAttribute('data-ac-league-dots');
        if (String(lid) !== String(league)) return;
        var ix = parseInt(dot.getAttribute('data-ac-dot-index'), 10);
        if (!isNaN(ix)) showPage(ix);
      });
    });

    if (typeof ResizeObserver !== 'undefined') {
      attachRo();
    } else {
      window.addEventListener('resize', layout);
    }

    initAllSwipers();
    selectLeague(0);

    if (root.getAttribute('data-ac-league-icons-url') && window.__allianceCatsHydrateClubLogos) {
      window.__allianceCatsHydrateClubLogos(root);
    }
  }

  function scan(container) {
    function wrapBind(el, opts) {
      var run = function () {
        allianceCatsBindCarousel(el, opts);
      };
      if (window.homeCarouselDefer && typeof window.homeCarouselDefer.whenReady === 'function') {
        window.homeCarouselDefer.whenReady(el, run);
      } else {
        run();
      }
    }
    Array.prototype.slice.call(container.querySelectorAll('[data-alliance-cats]') || []).forEach(function (el) {
      wrapBind(el, { attrBound: 'data-ac-js' });
    });
    Array.prototype.slice.call(container.querySelectorAll('[data-alliance-cats-standalone]') || []).forEach(function (el) {
      wrapBind(el, { attrBound: 'data-ac-standalone-js' });
    });
  }

  window.allianceCatsBindCarousel = allianceCatsBindCarousel;

  if (!window.__allianceCatsAcSwiperInit) {
    window.__allianceCatsAcSwiperInit = true;
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) scan(e.target);
    });
  } else {
    scan(document);
  }
})();
